/*
  The header's Learn menu.

  The course is the first thing in it and the reason it exists: there will be
  more courses, and a tab that holds one can hold the next. It is a featured
  card in the same shape the products and pricing menus use, so the three
  menus read as one system, and the links beside it are the places on the
  site that teach rather than sell.

  Kept apart from products.ts on purpose. That file is derived from the
  product catalogue, and a course is not a product.
*/
/*
  Two cards now. The course came first and stays first; the video library
  sits beside it. Both are pictures of the thing they lead to: the course
  card is a crop of its page's hero ground, the videos card is the channel's
  own frame, cropped to the same 800x320 strip for the same reason.
*/
export const LEARN_MENU_FEATURES = [
  {
    href: '/agent-readiness-course',
    /*
      A crop of the course page's own hero ground, 800x320 for a strip 132px
      tall, for the same reason the products card carries a crop rather than
      the full-bleed picture: object-fit would throw away most of what was
      downloaded. It is the same picture the page opens on, so the card and
      the page it leads to are visibly the same thing.
    */
    photo: '/design-system/mega-menu/learn-course.webp',
    /* The phone sheet renders this menu as rows, and a row needs a label
       shorter than a card's title and blurb. */
    short: 'The Agent Readiness Course',
    title: 'The Agent Readiness Course',
    blurb: 'A free seven-email course on how AI reads your business, and how to make sure it gets you right. Each email is a two-minute read.',
    cta: 'Start the course',
  },
  {
    href: '/learn',
    photo: '/design-system/mega-menu/learn-aeo.webp',
    short: 'Videos',
    title: 'Learn AEO in short videos',
    blurb: 'How AI decides who to recommend, and what to do about it on your own site. A few minutes each, with new ones as they are made.',
    cta: 'Watch the videos',
  },
]

/** The first card, kept for the places that only need one. */
export const LEARN_MENU_FEATURE = LEARN_MENU_FEATURES[0]

/* A sentence, not an uppercase eyebrow: this system does not have eyebrows. */
export const LEARN_MENU_GROUP = 'More to read'

export const LEARN_MENU_LINKS = [
  { href: '/docs', name: 'Documentation', blurb: 'Guides and reference for every part of SuperSchema.' },
  { href: '/methodology', name: 'Methodology', blurb: 'How the scan reads a site, and what it does not claim.' },
  { href: '/resources', name: 'Blog', blurb: 'Writing on how AI reads the web.' },
  { href: '/customers', name: 'Customer stories', blurb: 'The companies using SuperSchema.' },
]
